module.exports = __webpack_public_path__ + "static/img/enviroPoly-HDPE-sign.81f6830.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/routed-plastic/enviroPoly-HDPE-sign.jpg
// module id = 691
// module chunks = 0